import styles from './Footer.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setBaseRegion} from "../Reducer/GlobalReducer";
import imHalva from '../Img/Footer/halva.svg'
import imVisa from '../Img/Footer/visa.svg'
import imMaestro from '../Img/Footer/maestro.svg'
import imMaster from '../Img/Footer/mastercard.svg'

import imSbp from '../Img/Footer/sbp.svg'
import imMir from '../Img/Footer/mir.svg'


import lgMax from '../Img/Footer/max.svg'
import lgVk from '../Img/Footer/vk.svg'
import lgTelegram from '../Img/Footer/telegram.svg'




import React from "react";
import {Link} from "react-router-dom";
export default function Footer(){
    const baseUrl = useSelector((state: ReduxStateInt) => {
        return state.baseUrl
    })
    const dispatch = useDispatch()

    const baseRegion = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })
    const mobileMode = useSelector((state:ReduxStateInt)  => {return state.mobileMode})


    return(
        <div className={[styles.mainCont, mobileMode ? styles.sqFooter : ""].join(' ')}>
            <div className={"row"}>
            </div>
            <div className={"row"}>
                <div className={"col-sm-4 align-items-center mb-sm-2"}>
                    <div className={styles.blCont}>
                        <div className={styles.ctTitle}>Контакты</div>
                        <div>630120, г.Новосибирск, ул.Железнодорожная 15/1 оф. 39</div>
                        {false &&<div>ИП Титов Д.Ю.</div>}
                        {false &&<div>ОГРНИП 314547602100390</div>}

                        <div className={styles.fileCont}>
                            < ><a  className={[styles.href, styles.link, styles.center].join(' ')} href={baseUrl+'/static/offer.docx'}>Публичная оферта</a></>
                            < ><a  className={[styles.href, styles.link, styles.center].join(' ')} href={baseUrl + '/static/refund-politic.docx'}>Политика возвратов</a></>
                            < ><a  className={[styles.href, styles.link, styles.center].join(' ')} href={baseUrl+'/static/ppd-politic.docx'}>Политика обработки персональных данных</a></>

                        </div>


                    </div>
                </div>
                <div className={"col-sm-4 align-items-center mb-sm-2"}>
                    <div className={styles.blCont}>
                        <div className={styles.ctTitle}>Режим работы</div>
                        <div>пн-пт 09.00 - 19.00 (Новосибирск)</div>
                        <div>тел. : <a href="tel:+79993046060">+79993046060</a></div>
                        <div>eMail : <a href="mailto:service@sim-unlim.com">service@sim-unlim.com</a></div>


                    </div>
                </div>
                <div className={"col-sm-4 align-items-center mb-sm-2"}>
                    <div className={styles.blCont}>
                        <div className={styles.ctTitle}>Принимаем оплату</div>
                        <div>
                            <img src={imSbp} onClick={()=>dispatch(setBaseRegion({...baseRegion,isChanged: false}))}></img>
                            <img src={imMir}></img>
                            <img src={imHalva}></img>

                        </div>
                        <div>
                            <img src={imVisa}></img>
                            <img src={imMaestro}></img>
                            <img src={imMaster}></img>

                        </div>


                    </div>
                </div>

            </div>
            <div className={"row"}>
                <div className={"col-sm-4 align-items-center mb-sm-2"}>
                        <div className={styles.socCoNt}>
                            <div className={styles.scTitle}>Мы в соц. сетях :</div>
                            <div className={styles.scRow}>
                                <Link to={"https://max.ru/join/sOT_zaWH8FKeUHF6MgaYpfkGyEHSbE8V01MoWEui_iw"} target={"_blank"} >
                                    <img src={lgMax} alt={"макс"}/>
                                </Link>
                                <Link to={"https://t.me/sim_unlim_com"} target={"_blank"}>
                                    <img src={lgTelegram} alt={"телеграм"}/>
                                </Link>
                                <Link to={"https://vk.ru/simunlim_nsk"} target={"_blank"} >
                                    <img src={lgVk} alt={"вконтакте"}/>
                                </Link>

                            </div>


                        </div>
                </div>



            </div>


        </div>
    )
}
